// extracted by mini-css-extract-plugin
export default {"downBox":"howToUse_downBox__dbP+b"};